import React, { useState } from "react";
import styles from "./ModalCollapse.module.scss";

const ModalCollapse = () => {
  const modalCollapse = [
    {
      heading: "Where is Radiance Homes Patiala Located?",
      desc: "The Radiance Homes Patiala is located strategically on Patiala - Rajpura Highway, Urban Estate Phase II, Patiala",
    },
    {
      heading: "What is the completion date of Radiance Homes Patiala?",
      desc: "Radiance Homes Patiala is expected to be completed in 2027, with construction currently in progress.",
    },
    {
      heading: "How many total flats are there in Radiance Homes Patiala?",
      desc: "The total number of flats in Radiance Homes Patiala is 190, which includes 184 regular flats and 6 penthouses.",
    },
    {
      heading:
        "How many storeys are there for the 3BHK and 4BHK units in Radiance Homes Patiala?",
      desc: "The 3 BHK units tower has 16 storeys, while the 4BHK are in 17 storeys towers.",
    },
    {
      heading: "What is the starting price of Radiance Homes Patiala?",
      desc: "The starting price of Radiance Homes Patiala is ₹1.24 crore (BSP).",
    },
    {
      heading: "What is the total land area of Radiance Homes Patiala?",
      desc: "The total land area of Radiance Homes Patiala is 2.56 acres.",
    },
    {
      heading: "How many towers are there in Radiance Homes Patiala?",
      desc: "Radiance Homes Patiala is constructing a total of 4 towers.",
    },
    {
      heading: "What types of products are offered at Radiance Homes Patiala?",
      desc: "Radiance Homes Patiala offers 3 BHK, 4 BHK apartments, and penthouses.",
    },
    {
      heading:
        "How many flats are there on each floor at Radiance Homes Patiala?",
      desc: "There are 4 flats of 3 BHK and 2 flats of 4 BHK on each floor at Radiance Homes Patiala.",
    },
    {
      heading:
        "How many lifts are there in each tower of Radiance Homes Patiala?",
      desc: "There are 3 lifts in each tower of Radiance Homes Patiala.",
    },
  ];

  const [expandModal, setExpandModal] = useState(-1);

  const toggleExpand = (index) => {
    if (expandModal === index) setExpandModal(-1);
    else setExpandModal(index);
  };

  return modalCollapse.map((item, index) => {
    return (
      <>
        <div
          key={index}
          className={styles.quesContainer}
          onClick={() => toggleExpand(index)}
        >
          <p className={styles.question}>{item?.heading}</p>
          <i
            className={
              expandModal === index
                ? "fas fa-chevron-up"
                : "fas fa-chevron-down"
            }
          ></i>
        </div>
        <div
          className={`${styles.answerContainer} ${
            expandModal === index ? styles.expand : ""
          }`}
        >
          <p className={styles.answer}>{item?.desc}</p>
        </div>
      </>
    );
  });
};

export default ModalCollapse;
